import type { BucketId } from './map-layout';

/**
 * Where the ONE back control above an open map-home section goes.
 *
 * The section chrome owns this control — the single slot at the top of the open section — and no body
 * rendered inside it may add a second. It used to: the Outreach tab drew its own "Contacts" back button
 * under the chrome's "Back to the map", so a contact's detail carried TWO stacked back buttons. The rule
 * is one control, one place, and it steps back ONE level:
 *
 * - a contact open inside the Outreach tab → back to that tab's list (the tab stays open), and
 * - anything else → back to the map (the tab closes).
 *
 * Pure so it can be tested without a DOM (orion-web jest runs in node). Typed off `BucketId` rather than
 * the component's `MapTab` so the lib does not reach up into `components/`; the two are the same union.
 */
export type MapSectionBackTarget = 'map' | 'outreach';

export function mapSectionBack(tab: BucketId | 'activity' | null, hasContact: boolean): MapSectionBackTarget | null {
  if (!tab) return null;
  return tab === 'messages' && hasContact ? 'outreach' : 'map';
}
